import { useMutation, UseMutationConfig } from '@libs/use';

import * as API from '../../requests';

type UseDeleteEmbeddedPutOptionRequestOptions = {
  onReject?: UseMutationConfig<object>['onReject'];
  onSuccess?: UseMutationConfig<object>['onSuccess'];
};

export default function useDeleteEmbeddedPutOptionRequestQuery({
  onReject,
  onSuccess,
}: UseDeleteEmbeddedPutOptionRequestOptions = {}) {
  const {
    execute: deleteEmbeddedPutOptionRequest,
    isPending: isLoadingDeleteEmbeddedPutOptionRequest,
    ...query
  } = useMutation(
    ({ isin }: { isin: string }) => API.deleteEmbeddedPutOptionRequest(isin),
    {
      onSuccess,
      onReject,
    }
  );

  return {
    deleteEmbeddedPutOptionRequest,
    isLoadingDeleteEmbeddedPutOptionRequest,
    ...query,
  };
}
